export default "__VITE_ASSET__j9nNqALX__"